import type {
  CartFulfillEvents,
  CartQuoteEvents,
  CartUpdateEvents,
  AirPriceFreezeEvents,
} from "@hopper-b2b/checkout";
import type { UberPaymentEvents } from "../../checkout/states/payments";

export enum Event {
  // CommonEvents
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",

  // Confirmation
  GO_HOME = "GO_HOME",

  // Transition to state from query params
  GO_TO_PRICE_FREEZE_OFFER = "GO_TO_PRICE_FREEZE_OFFER",
  GO_TO_QUOTE = "GO_TO_QUOTE",
  GO_TO_PAYMENT = "GO_TO_PAYMENT",
  GO_TO_FULLFILL = "GO_TO_FULLFILL",
  GO_TO_FULLFILL_FAILED = "GO_TO_FULLFILL_FAILED",
  GO_TO_PRICE_FREEZE_CONFIRMATION = "GO_TO_PRICE_FREEZE_CONFIRMATION",
}

export interface NextEvent {
  type: Event.NEXT;
}
export interface PreviousEvent {
  type: Event.PREVIOUS;
}

export interface GoHomeEvent {
  type: Event.GO_HOME;
}

export interface GoToPriceFreezeOffer {
  type: Event.GO_TO_PRICE_FREEZE_OFFER;
}

export interface GoToQuote {
  type: Event.GO_TO_QUOTE;
}

export interface GoToPayment {
  type: Event.GO_TO_PAYMENT;
}

export interface GoToFullfill {
  type: Event.GO_TO_FULLFILL;
}

export interface GoToFullfillFailed {
  type: Event.GO_TO_FULLFILL_FAILED;
}

export interface GoToPriceFreezeConfirmation {
  type: Event.GO_TO_PRICE_FREEZE_CONFIRMATION;
}

export type TEvent =
  | GoHomeEvent
  | NextEvent
  | PreviousEvent
  | GoToPriceFreezeOffer
  | GoToQuote
  | GoToPayment
  | GoToFullfill
  | GoToFullfillFailed
  | GoToPriceFreezeConfirmation
  | CartFulfillEvents
  | CartQuoteEvents
  | CartUpdateEvents
  | UberPaymentEvents
  | AirPriceFreezeEvents;
